const API_CONFIG = {
  BASE_URL: process.env.VUE_APP_API_URL || (process.env.NODE_ENV === 'production' 
    ? 'https://kaszk.komornikantal.hu/api' 
    : 'http://localhost:3000/api'),
  
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      STATUS: '/auth/status'
    },
    STUDENTS: '/students',
    MAJORS: '/majors',
    LANGUAGES: '/languages',
    EXPORT: {
      EXCEL: '/export/excel'
    }
  }
}

export default API_CONFIG